import { render, staticRenderFns } from "./AutoupdateManage.vue?vue&type=template&id=4f714bda&"
import script from "./AutoupdateManage.vue?vue&type=script&lang=js&"
export * from "./AutoupdateManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f714bda')) {
      api.createRecord('4f714bda', component.options)
    } else {
      api.reload('4f714bda', component.options)
    }
    module.hot.accept("./AutoupdateManage.vue?vue&type=template&id=4f714bda&", function () {
      api.rerender('4f714bda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Wordpress/Autoupdate/AutoupdateManage.vue"
export default component.exports